import React from 'react';

const Word = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    viewBox="0 0 128 128"
  >
    <path
      d="M71.8 18.84v90.35l-10.54-1.8-40-6.9C18 99.9 18 100 18 96.6c0-22 0-44.04-.1-66.06 0-2.13.5-3 2.6-3.35 16.5-2.8 33.02-5.7 49.54-8.5.45-.1.92 0 1.67 0M43.3 58.2l.66.1c1.2 6.1 2.53 12.2 3.55 18.33.4 2.4 1.3 3.47 3.7 3.1.3-.04.7-.02 1 .05 1.7.33 2.3-.33 2.6-2 1.5-7.78 3.2-15.54 4.9-23.3.5-2.37 1-4.76 1.5-7.45-1.5.17-2.4.42-3.4.38-1.8 0-2.5.7-2.7 2.5-.7 5.5-1.7 11-2.6 16.4-.23 1.5-.6 2.9-.86 4.3l-.54-.1-4.3-22.3c-1.1.1-1.9.3-2.6.3-2.16-.15-3 .77-3.4 3-1 5.74-2.25 11.44-3.43 17.16-.1.54-.33 1.05-.5 1.57-1.36-5.92-2.2-11.76-3.18-17.6-.6-3.7-.7-3.7-4.3-3.03-.25 0-.45.12-1 .34l5.4 28.97h5.53l4.17-20.45m30.18 39v-9.8h27.9v-3.5H73.6v-5.8h27.85V74.9H73.6v-5.8h27.9v-3.4H73.6v-5.82h27.8v-3.5H73.55v-5.72h27.87v-3.5h-27.9v-5.8h27.93v-3.4H73.57v-9c.78-.04 1.5-.12 2.24-.12 10.5 0 20.9.05 31.4-.04 2.1 0 2.9.56 2.9 2.86v63.1c0 1.6 0 2.9-2.2 2.9-11.1-.03-22.2 0-33.4 0-.2 0-.4-.08-.9-.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#2B5797"
    />
  </svg>
);

export default Word;
